<template>
  <div class="ml-auto mr">
    <v-col cols="12" class="mr-auto ml-auto">
      <v-form ref="projectReportEntriesForm">
        <p class="text-h5 mb-7">
          {{ languageData.projectReportEntries.head }}
        </p>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-menu
                ref="projectReportEntriesDate"
                v-model="menuProjectReportEntriesDate"
                :close-on-content-click="false"
                :return-value.sync="activePickerDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="projectReportEntries.date"
                    :label="languageData.labels.start_date"
                    :rules="startDateRules"
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="projectReportEntries.date"
                  no-title
                  scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="menuProjectReportEntriesDate = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.projectReportEntriesDate.save(projectReportEntries.date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-menu
                ref="projectReportEntriesTermin"
                v-model="menuProjectReportEntriesTermin"
                :close-on-content-click="false"
                :return-value.sync="activePickerTermin"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    outlined
                    v-model="projectReportEntries.termin"
                    :label="languageData.labels.termin"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="projectReportEntries.termin"
                  no-title
                  scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="menuProjectReportEntriesTermin = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.projectReportEntriesTermin.save(projectReportEntries.termin)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-textarea
                class="mt-5"
                outlined
                :label="languageData.labels.another_project_report_entry"
                v-model="projectReportEntries.description"
                :rules="descriptionRules"
                rows="5"></v-textarea>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-textarea
                class="mt-5"
                outlined
                :label="languageData.labels.remarks"
                v-model="projectReportEntries.remarks"
                rows="5"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-select
                v-model="projectReportEntries.typ"
                :items="typeOptions"
                :label="languageData.labels.typ"
                outlined

            ></v-select>
          </v-col>

          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-menu
                ref="projectReportEntriesDatum"
                v-model="menuProjectReportEntriesDatum"
                :close-on-content-click="false"
                :return-value.sync="activePickerDatum"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="projectReportEntries.datum"
                    :label="languageData.labels.datum"
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="projectReportEntries.datum"
                  no-title
                  scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="menuProjectReportEntriesDatum = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.projectReportEntriesDatum.save(projectReportEntries.datum)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-text-field
                v-model="projectReportEntries.location"
                :label="languageData.labels.location"
                outlined
            ></v-text-field>
          </v-col>

          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-select
                v-model="projectReportEntries.subcontractor"
                :items="subcontractorOptions"
                :label="languageData.labels.subcontractor"
                outlined
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Sie haben kein Unternehmen als Subunternehmer hinzugefügt
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <div class="d-flex justify-end">
          <v-btn
              class="button-shadow mb-5"
              color="primary"
              :loading="projectEntryDataIsSaving || projectEntryDataIsUpdating"
              @click="saveOrUpdateProjectReportEntry"
             >{{ languageData.btnSubmit }}</v-btn>
        </div>
      </v-form>
    </v-col>
    <ModalInfo
        :typeInfo="typeInfoProjectEntrySave || typeInfoProjectEntryUpdate"
        :headModal="headInfoProjectEntrySave || headInfoProjectEntryUpdate"
        :btnAgreeText="languageData.btnAgreeText"
        :visDisAgreeBtn="false"
        @clicked="hideProjectEntryModal"
        :show-modal="isProjectEntrySave || isProjectEntryUpdate"
        :text-modal="textInfoProjectEntrySave || textInfoProjectEntryUpdate">
    </ModalInfo>
  </div>
</template>

<script type="text/javascript">
  import {mapActions, mapState} from "vuex";
  import eventBus from "../../../event-bus/eventBus";
  import ModalInfo from "../../../components/ModalInfo/ModalInfo";

  export default {
    name: "ProjectReportEntriesForm",
    components: {ModalInfo},
    props: {
      projectReportEntryId: Number,
      projectReportEntriesEditData: Object,
      layout: String
    },
    computed: {
      ...mapState("saveProjectEntry", {
        isProjectEntrySave: state => state.isProjectEntrySave,
        projectEntryDataIsSaving: state => state.projectEntryDataIsSaving,
        textInfoProjectEntrySave: state => state.textInfoProjectEntrySave,
        headInfoProjectEntrySave: state => state.headInfoProjectEntrySave,
        typeInfoProjectEntrySave: state => state.typeInfoProjectEntrySave,
      }),
      ...mapState("updateProjectEntry", {
        isProjectEntryUpdate: state => state.isProjectEntryUpdate,
        projectEntryDataIsUpdating: state => state.projectEntryDataIsUpdating,
        textInfoProjectEntryUpdate: state => state.textInfoProjectEntryUpdate,
        headInfoProjectEntryUpdate: state => state.headInfoProjectEntryUpdate,
        typeInfoProjectEntryUpdate: state => state.typeInfoProjectEntryUpdate,

      })
    },
    methods: {
      ...mapActions("saveProjectEntry", ["storeProjectEntry", "updateVisibleModalSave"]),
      ...mapActions("updateProjectEntry", ["updateProjectEntry", "updateVisibleModalUpdate"]),
      ...mapActions("getClients", ["getClients"]),
      saveOrUpdateProjectReportEntry: function () {
        this.$refs.projectReportEntriesForm.validate();
          if (this.layout === "edit") {
            this.updateProjectReportEntry();
          } else {
            this.saveProjectReportEntry();
          }
      },
      saveProjectReportEntry: function () {
        this.storeProjectEntry( { creds: this.projectReportEntries });
      },
      updateProjectReportEntry: function () {
        this.updateProjectEntry({ creds: this.projectReportEntries });
      },
      hideProjectEntryModal() {
        if(this.layout === 'edit') {
          this.updateVisibleModalUpdate(false);
        } else {
          this.updateVisibleModalSave(false);
        }
      }
    },
    data() {
      return {
        projectReportEntries: {
          date: "",
          termin: "",
          note: "",
          remarks: "",
          location: "",
          typ: "",
          datum: "",
          subcontractor: "",
        },
        subcontractorOptions: [],
        typeOptions: [
          { text: 'FREIGABE', value: 1 },
          { text: 'BEHINDERUNG', value: 2 },
          { text: 'MÄNGEL', value: 3 },
          { text: 'ANDERE', value: 4 }
        ],
        startDateRules: [
          v => !!v || this.languageData.rules.startDate
        ],
        descriptionRules: [
          v => !!v ||  this.languageData.rules.description
        ],
        activePickerDate: null,
        activePickerTermin: null,
        activePickerDatum: null,
        menuProjectReportEntriesDate: false,
        menuProjectReportEntriesTermin: false,
        menuProjectReportEntriesDatum: false,
        errors: [],
      }
    },
    mounted() {
      eventBus.$on("saveOrUpdateProjectEntrySuccess", (projectEntryDataReceive) => {
        this.$refs.projectReportEntriesForm.reset();
        eventBus.$emit("showSnackbarSuccess", projectEntryDataReceive);
      });
      eventBus.$on("saveOrUpdateProjectEntryFailure", (projectEntryDataReceive) => {
        eventBus.$emit("showSnackbarFailure", projectEntryDataReceive);
      });
      eventBus.$on("showEditProjectReportEntriesModal", (item) => {
        this.projectReportEntries = item;
      });
      eventBus.$on("showAddProjectEntryModal", () => {
        this.projectReportEntries =  {
          date: "",
          termin: "",
          value: "",
          note: "",
          remarks: "",
          location: "",
          typ: "",
          datum: "",
          subcontractor: "",
        };
        this.$refs.projectReportEntriesForm.resetValidation();
      })
      if(this.layout === "edit") {
        this.projectReportEntries = this.projectReportEntriesEditData;
      }
      this.getClients({
        valueSearch: {}
      });

      eventBus.$on("getClientsSuccess", (clients) => {
        console.log(clients);
        this.subcontractorOptions = clients
            .filter(client =>
                client.projectClientTypes.some(type => type.client_type === 3)
            )
            .map(client => ({
              text: client.name,
              value: client.id
            }));
      });
    }
  }
</script>